<template>
    <div>
        <b-row>
            <b-col sm="12" md="5">
                <b-alert show>
                    <span>
                        Tipo da Fase:
                        <strong>{{ faseContratoTemp.tipoFaseContrato }}</strong>
                        <br />Descrição:
                        <strong>{{ faseContratoTemp.descricao }}</strong>
                        <br />Vigência:
                        <strong>
                            {{
                                faseContratoTemp.dataInicioVigencia
                                    ? $moment(
                                          faseContratoTemp.dataInicioVigencia
                                      ).format('DD/MM/YYYY')
                                    : ''
                            }}
                            a
                            {{
                                faseContratoTemp.dataFimVigencia
                                    ? $moment(
                                          faseContratoTemp.dataFimVigencia
                                      ).format('DD/MM/YYYY')
                                    : ''
                            }}
                        </strong>
                        <br />Valor:
                        <strong>{{ faseContratoTemp.valor | currency }}</strong>
                        <br />Sem Registro:
                        <strong>{{
                            faseContratoTemp.disponivel | currency
                        }}</strong>
                    </span>
                </b-alert>
            </b-col>
            <b-col sm="12" md="7">
                <app-tabela
                    :itens="detalhesFaseContrato"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button variant="danger" @click.stop="voltar()">
                                <span>
                                    <i class="fa fa-history mr-2"></i> Retornar
                                    para Fases
                                </span>
                            </b-button>
                        </b-button-group>
                    </template>
                    <template slot="valor" slot-scope="data">
                        <p class="text-right m-0">
                            {{ data.valor | currency }}
                        </p>
                    </template>
                    <template slot="comprometido" slot-scope="data">
                        <app-status
                            :status="data.comprometido ? 'SIM' : 'NÃO'"
                        ></app-status>
                    </template>
                    <template slot="competencia" slot-scope="data">{{
                        data.mesPrevisto
                            ? $moment(data.mesPrevisto).format('MM/YYYY')
                            : ''
                    }}</template>
                    <template slot="mesPrevisto" slot-scope="data">{{
                        data.mesPrevisto
                            ? $moment(data.mesPrevisto).format('MM/YYYY')
                            : ''
                    }}</template>
                </app-tabela>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        faseContrato: {
            type: Object,
            default: () => {}
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            detalhesFaseContrato: [],
            campos: [],
            faseContratoTemp: {},
            camposParcelaFixa: [
                {
                    key: 'competencia',
                    label: 'Competência',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'vencimento',
                    label: 'Vencimento',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'comprometido',
                    label: 'Comprometido',
                    sortable: true,
                    tdClass: 'text-center'
                }
            ],
            camposEntrega: [
                {
                    key: 'descricao',
                    label: 'Produto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'mesPrevisto',
                    label: 'Mês Previsto',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'comprometido',
                    label: 'Comprometido',
                    sortable: true,
                    tdClass: 'text-center'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {
        obterFase() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterFasePorId(
                    this.$route.params.contratoId,
                    this.faseContrato.faseContratoId
                )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.detalhesFaseContrato = response.data
                            this.faseContratoTemp.disponivel =
                                response.data.disponivel
                            this.faseContratoTemp.temComprometimento =
                                response.data.temComprometimento
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        voltar() {
            this.$emit('fecharDetalhesFaseContrato')
        }
    },

    created() {
        if (this.faseContrato.tipoFaseContratoId === 1) {
            this.campos = this.camposParcelaFixa
        } else if (this.faseContrato.tipoFaseContratoId === 2) {
            this.campos = this.camposEntrega
        }
        this.faseContratoTemp = this.faseContrato
        this.obterFase()
    }
}
</script>
